import styled from 'styled-components';

import { ANIM, COLORS } from '../../theme/tokens';

// A bare, compact icon button: no border chrome, a faint glyph that brightens on
// hover under the area's hover wash, and a visible focus ring. It sits inline
// beside a value (a host, an address, a DNS record), so it is padding-sized
// around the glyph rather than a fixed control box.
export const Root = styled.button`
  display: inline-grid;
  place-items: center;
  flex: 0 0 auto;
  padding: 6px;
  border: none;
  border-radius: 7px;
  background: transparent;
  color: ${COLORS.textFaint};
  line-height: 0;
  cursor: pointer;
  transition:
    background ${ANIM.INTERACT_MS}ms,
    color ${ANIM.INTERACT_MS}ms;

  &:hover {
    background: ${COLORS.hoverWash};
    color: ${COLORS.textMuted};
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.accent};
    outline-offset: 2px;
  }
`;
